import { useEffect, useState } from 'react';
import { ManagerOptions, Socket, io } from 'socket.io-client';
import { TARA_BASE_URL } from '../constants/url';
import { getHeaders } from '../utils/fetch';
import { getUserInfo } from '../utils/user';

function useSocket() {
    const [socket, setSocket] = useState<Socket>();

    const connect = (query: ManagerOptions['query']) =>
        new Promise<Socket>((resolve) => {
            getUserInfo().then((userInfo) => {
                const { hostname, pathname } = window.location;
                const subDomain =
                    hostname === 'bus.ixigo.com' || pathname.startsWith('/buses') ? 'abhibus' : hostname.split('.')[1];

                const socketInstance = io(`https://${subDomain}.elitedesk.in`, {
                    path: `${TARA_BASE_URL}/socket/chat`,
                    transports: ['websocket', 'polling'],
                    query,
                    auth: { ...getHeaders(), cookie: document.cookie, userid: userInfo?.userId },
                    withCredentials: true,
                });

                setSocket(socketInstance);

                socketInstance.on('connect_error', (err) => {
                    err.message = `Websocket connection error, opted for polling: ${err.message}`;

                    // In case `websocket` connection fails, communicate through `polling`.
                    socketInstance.io.opts.transports = ['polling', 'websocket'];
                });

                resolve(socketInstance);
            });
        });

    useEffect(
        () => () => {
            socket?.close();
        },
        [],
    );

    return { connect };
}

export default useSocket;
